document.addEventListener('DOMContentLoaded', function(){

  const collectionContainerSelector = '[js-collection-products-wrapper]';
  const filterMainContainerSelector = '[js-custom-filter-main-container]';
  const filterOpenBtnSelector = '[js-filter-open-btn]';
  const filterCloseBtnSelector = '[js-filter-close-btn]';
  const filterFormSelector = '[js-cus-filter-form]';
  const filterFormSubmitBtnSelector = '[js-cus-submit-btn]';
  const filterInputSelector = '[ js-cus-option-input ]';
  const removeFilterSelector = '[js-cus-active-filter-remove]';
  const filterInnerWrapperSelector = '[js-cus-fillter-inner]';
  const oneGridSelector = '[js-cus-one-grid ]';
  const twoGridSelector = '[js-cus-two-grid ]';
  const productGridSelector = '[js-product-grids]';
  const girdBtnSelector = '[js-grid-btn]';
  const slimeTypeOpenBtnSelector = '[js-cus-open-slime-type]';
  const slimeTypeCloseBtnSelector = '[js-cus-close-slime-type]'
  const accordionSelector = '[js-cus-accordion]';
  const accordionHeaderSelector = '[js-cus-accordion-header]';

  function replaceUrlHistory (url, query){
    if(query){
      url = `${url}?${query}`
    } else {
      url = `${url}`
    }
    window.history.pushState('','', url)
  }

  function fetchData(url, query){
    
    if(query){
      url = `${url}?view=ajax&${query}`
    } else {
      url = `${url}?view=ajax`
    }

    document.querySelector(filterFormSubmitBtnSelector).classList.add('loading-button')
    fetch(url)
      .then(response => {
        return response.text()
      })
      .then(doc => {
        const parser = new DOMParser()
        const html = parser.parseFromString(doc, 'text/html')
        const ajaxCollection = html.querySelector(collectionContainerSelector)
        document.querySelector(collectionContainerSelector).replaceWith(ajaxCollection)
        document.querySelector(filterFormSubmitBtnSelector).classList.remove('loading-button')
        window.quickAddToCart();
      })
  }

  function collectionFilter(selectedForm){
    const formData = new FormData(selectedForm)
    const queryString = new URLSearchParams(formData).toString();
    const url = `${location.origin}${location.pathname}`;

    fetchData(url, queryString)
  }

  function showProductCount(form) {
    const formData = new FormData(form)
    const query = new URLSearchParams(formData).toString();
    let url = `${location.origin}${location.pathname}`;
    replaceUrlHistory(url, query)

    if(query){
      url = `${url}?view=ajaxProductCount&${query}`
    } else {
      url = `${url}?view=ajaxProductCount`
    }

    fetch(url)
      .then(response => {
        return response.text()
      })
      .then(doc => {
        const parser = new DOMParser()
        const html = parser.parseFromString(doc, 'text/html')
        const ajaxCollection = html.querySelector('#filterResult')
        document.querySelector('#filterResult').replaceWith(ajaxCollection)
      })
  }
  
  document.addEventListener('click', function(e) {

    const filterOpenBtn = document.querySelector(filterOpenBtnSelector);
    const filterCloseBtn = document.querySelector(filterCloseBtnSelector);
    const filterMainContainer = document.querySelector(filterMainContainerSelector);
    const filterFormSubmitBtn = document.querySelector(filterFormSubmitBtnSelector);
    const filterInnerWrapper = document.querySelector(filterInnerWrapperSelector);
    const oneGrid = document.querySelector(oneGridSelector);
    const twoGrid = document.querySelector(twoGridSelector);
    const productGrid = document.querySelector(productGridSelector);
    const girdBtns = document.querySelectorAll(girdBtnSelector);
    const slimeTypeOpenBtn = document.querySelector(slimeTypeOpenBtnSelector);
    const slimeTypeClosenBtn = document.querySelector(slimeTypeCloseBtnSelector);
    const accordionHeaders = document.querySelectorAll(accordionHeaderSelector);

    if(filterOpenBtn.contains(e.target)) {
      filterMainContainer.style.opacity = 1;
      filterMainContainer.style.visibility = 'visible';
      document.body.classList.add('filter-activated');
    }

    if(filterCloseBtn.contains(e.target)) {
      filterMainContainer.style.opacity = 0;
      filterMainContainer.style.visibility = 'hidden';
      document.querySelector('html').style.overflow = 'scroll';
      document.body.classList.remove('filter-activated');
    }


    if(slimeTypeOpenBtn.contains(e.target)) {
      filterInnerWrapper.classList.add('slime-type-active')
    }

    if(slimeTypeClosenBtn.contains(e.target)) {
      filterInnerWrapper.classList.remove('slime-type-active')
    }

    document.querySelectorAll(filterInputSelector).forEach(btn => {
      if(btn.contains(e.target)){
        const filterForm = document.querySelector(filterFormSelector)
        showProductCount(filterForm)
      }
    })

    document.querySelectorAll(removeFilterSelector).forEach(btn => {
      if(btn.contains(e.target)){
        document.querySelectorAll(filterInputSelector).forEach(input => {
          if(input.value == btn.getAttribute('data-label')) {
            input.checked = false;
            const filterForm = document.querySelector(filterFormSelector)
            collectionFilter(filterForm)
          }
        })
      }
    })

    if(filterFormSubmitBtn.contains(e.target)) {
      e.preventDefault();
      const filterForm = document.querySelector(filterFormSelector)
      collectionFilter(filterForm)
    }

    if(!filterInnerWrapper.contains(e.target) && !filterOpenBtn.contains(e.target)) {
      filterMainContainer.style.opacity = 0;
      filterMainContainer.style.visibility = 'hidden';
      document.querySelector('html').style.overflow = 'scroll';
      document.body.classList.remove('filter-activated');
    }

    if(oneGrid.contains(e.target)) {
      girdBtns.forEach(btn => {
        btn.classList.remove('active');
      })
      productGrid.classList.add('grid-one');
      oneGrid.classList.add('active');
    }

    if(twoGrid.contains(e.target)) {
      girdBtns.forEach(btn => {
        btn.classList.remove('active');
      })
      productGrid.classList.remove('grid-one');
      twoGrid.classList.add('active');
    }

    if(window.innerWidth < 769) {
      accordionHeaders.forEach(header => {
        if(header.contains(e.target)){
          console.log('header trigger')
          const parent = e.target.closest(accordionSelector);
          if(parent.classList.contains('active')) {
            parent.classList.remove('active');
          } else {
            parent.classList.add('active');
          }
        }
      })
    }


  })

});
